export const IN_PROGRESS = 'in-progress'
export const SCHEDULED = 'scheduled'
export const COMPLETE = 'complete'
export const SUSPENDED = 'suspended'
export const DELAYED = 'delayed'
export const POSTPONED = 'postponed'
export const RETIRED = 'retired'
export const CANCELED = 'canceled'
export const UNKNOWN = 'unknown'
export const statusClassNames = {
  [IN_PROGRESS]: 'in-progress',
  [SCHEDULED]: 'scheduled',
  [COMPLETE]: 'complete',
  [RETIRED]: 'retired',
  [CANCELED]: 'canceled',
  [POSTPONED]: 'postponed',
}

export const statusLabels = {
  [IN_PROGRESS]: 'Live',
  [SCHEDULED]: 'Upcoming',
  [COMPLETE]: 'Final',
  [SUSPENDED]: 'Suspended',
  [DELAYED]: 'Delayed',
  [POSTPONED]: 'Postponed',
  [RETIRED]: 'Retired',
  [CANCELED]: 'Canceled',
  [UNKNOWN]: '-',
}
